module.exports = __webpack_public_path__ + "img/empty.03a21d1e.svg";